export default __webpack_public_path__ + "static/media/Professional_services.8df200ed.png";